import { Loader } from '@googlemaps/js-api-loader'

/**
 * geocoderAPIに住所を投げて結果を一つ返す
 */
const getGeocoderResult: (params: {
  apiKey: string
  address: string
  onGetResult: (result: google.maps.GeocoderResult) => void
}) => void = ({ apiKey, address, onGetResult }) => {
  const loader = new Loader({
    apiKey,
    version: 'weekly',
  })
  return loader
    .load()
    .then(() => {
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === 'OK') {
          onGetResult(results[0])
        } else {
          throw new Error(
            'Geocode was not successful for the following reason: ' + status
          )
        }
      })
    })
    .catch((e) => {
      throw new Error(e)
    })
}

export default getGeocoderResult
